const initProductKeyFeatures = (scope = document) => {
  scope.querySelectorAll('[data-product-key-features]').forEach(root => {
    const toggle = root.querySelector('[data-product-key-features-toggle]');
    if (!toggle || toggle.dataset.productKeyFeaturesInit === 'true') return;

    const collapsedItems = root.querySelectorAll('[data-product-key-feature-collapsed]');
    if (!collapsedItems.length) return;

    const toggleShortTextEl = toggle.querySelector('[data-product-key-features-toggle-short]');
    const toggleFullTextEl = toggle.querySelector('[data-product-key-features-toggle-full]');

    toggle.dataset.productKeyFeaturesInit = 'true';

    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      collapsedItems.forEach(item => {
        if (isExpanded) {
          item.setAttribute('data-product-key-feature-collapsed', '');
        } else {
          item.removeAttribute('data-product-key-feature-collapsed');
        }
      });

      toggleShortTextEl?.classList.toggle('hidden', !isExpanded);
      toggleFullTextEl?.classList.toggle('hidden', isExpanded);
      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    });
  });
};

export default initProductKeyFeatures;
